export default function PHP_ob_implicit_flush() {
  return (
    <div>
      <h1>PHP_ob_implicit_flush</h1>
    </div>
  );
}
